import useSWR from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';

export const useLeadSource = <T>() => {
  const { data, mutate, error } = useSWR<T>(`/${SERVICES.LEAD}/source`, { revalidateOnMount: undefined });

  return {
    leadSourceData: data as T | undefined,
    reloadLeadSource: mutate,
    leadSourcesError: error
  };
};
